import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== Public API ====================

// Contacts
export const submitContact = async (contactData) => {
  const response = await api.post('/contacts', contactData);
  return response.data;
};

// Bookings
export const submitBooking = async (bookingData) => {
  const response = await api.post('/bookings', bookingData);
  return response.data;
};

export const getAvailableSlots = async (date) => {
  const response = await api.get(`/bookings/available-slots?date=${date}`);
  return response.data;
};

// Testimonials
export const getTestimonials = async () => {
  const response = await api.get('/testimonials');
  return response.data;
};

// FAQ
export const getFAQ = async () => {
  const response = await api.get('/faq');
  return response.data;
};

// Resources
export const getResources = async () => {
  const response = await api.get('/resources');
  return response.data;
};

// ==================== Admin API ====================

// Auth
export const adminLogin = async (password) => {
  const response = await api.post('/admin/login', { password });
  return response.data;
};

export const verifyAdminToken = async () => {
  const response = await api.post('/admin/verify');
  return response.data;
};

export const getAdminStats = async () => {
  const response = await api.get('/admin/stats');
  return response.data;
};

// Contacts (Admin)
export const getContacts = async () => {
  const response = await api.get('/contacts');
  return response.data;
};

export const updateContactStatus = async (contactId, status) => {
  const response = await api.patch(`/contacts/${contactId}/status`, { status });
  return response.data;
};

export const deleteContact = async (contactId) => {
  const response = await api.delete(`/contacts/${contactId}`);
  return response.data;
};

// Bookings (Admin)
export const getBookings = async () => {
  const response = await api.get('/bookings');
  return response.data;
};

export const updateBookingStatus = async (bookingId, status) => {
  const response = await api.patch(`/bookings/${bookingId}/status`, { status });
  return response.data;
};

export const deleteBooking = async (bookingId) => {
  const response = await api.delete(`/bookings/${bookingId}`);
  return response.data;
};

// Testimonials (Admin)
export const createTestimonial = async (data) => {
  const response = await api.post('/testimonials', data);
  return response.data;
};

export const toggleTestimonial = async (testimonialId) => {
  const response = await api.patch(`/testimonials/${testimonialId}/toggle`);
  return response.data;
};

export const deleteTestimonial = async (testimonialId) => {
  const response = await api.delete(`/testimonials/${testimonialId}`);
  return response.data;
};

// FAQ (Admin)
export const createFAQ = async (data) => {
  const response = await api.post('/faq', data);
  return response.data;
};

export const updateFAQ = async (faqId, data) => {
  const response = await api.put(`/faq/${faqId}`, data);
  return response.data;
};

export const deleteFAQ = async (faqId) => {
  const response = await api.delete(`/faq/${faqId}`);
  return response.data;
};

// Resources (Admin)
export const createResource = async (data) => {
  const response = await api.post('/resources', data);
  return response.data;
};

export const updateResource = async (resourceId, data) => {
  const response = await api.put(`/resources/${resourceId}`, data);
  return response.data;
};

export const deleteResource = async (resourceId) => {
  const response = await api.delete(`/resources/${resourceId}`);
  return response.data;
};

export default api;
